/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'member': {
    width: 11,
    height: 14,
    viewBox: '0 0 11 14',
    data: '<path pid="0" d="M5.431 7.573h-.009a4.904 4.904 0 00-3.54 1.486c-.942.97-1.46 2.29-1.456 3.723a.292.292 0 00.296.295h6.241v-.59h-5.94c.062-1.162.51-2.223 1.282-3.011A4.309 4.309 0 015.422 8.17h.01v-.597z" _fill="#fff"/><path pid="1" d="M5.315 7.573h.009a4.69 4.69 0 013.435 1.486c.914.97 1.416 2.29 1.413 3.723a.31.31 0 01-.083.21.28.28 0 01-.204.085H3.83v-.59h5.764c-.06-1.162-.496-2.223-1.244-3.011A4.12 4.12 0 005.324 8.17h-.009v-.597zM5.428 6.873a3.123 3.123 0 100-6.247 3.123 3.123 0 000 6.247zm0-5.656a2.532 2.532 0 110 5.065 2.532 2.532 0 010-5.065z" _fill="#fff"/>'
  }
})
